// src/components/LandingPage.jsx
import ManagerlogixLanding from "../marketing/managerlogix/ManagerlogixLanding";

export default function LandingPage() {
  return <ManagerlogixLanding />;
}
